module.exports = __webpack_public_path__ + "static/seconds-icon-square-small-e6a719fbab364aeb170a9c80292df4fe.png";